module.exports = __webpack_public_path__ + "img/dlsjjkxt.aa535f27.jpg";